/* src/app/webhook-creator/webhook-creator/webhook-edit/webhook-debug-log/webhook-debug-log.component.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  min-height: 100%;
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  min-height: 100%;
}
.variable-form {
  width: 50%;
  padding: 20px;
  float: right;
}
.variable-table .ant-select-selector {
  cursor: pointer;
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-container {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.edit-panel-container-left {
  width: 50%;
}
.edit-panel-container-right {
  width: 50%;
}
td.cell-normal {
  text-overflow: ellipsis;
  overflow: hidden;
  word-spacing: unset;
  width: 100%;
  white-space: nowrap;
}
::ng-deep .ant-table-cell {
  word-break: break-word;
}
.search-box {
  padding: 8px;
}
.search-box input {
  width: 188px;
  margin-bottom: 8px;
  display: block;
}
.search-box button {
  width: 90px;
}
.search-button {
  margin-right: 8px;
}
.edit-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.edit-panel-action {
  display: flex;
  flex-direction: row;
  width: 100%;
}
nz-divider::after,
nz-divider::before {
  border-color: var(--tem-deep) !important;
}
.tool-bar-button {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
}
.log-item {
  background-color: black;
  color: white;
  font-weight: 500;
  padding: 20px;
  border-radius: 16px;
  border-style: solid;
  overflow: auto;
}
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
}
.webhook-debug-log {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: auto;
}
nz-float-button {
  position: absolute;
  right: 40px;
  bottom: 120px;
}
.full-spin {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
.full-spin .ant-spin-nested-loading {
  flex: 1;
  height: 100%;
}
.full-spin .ant-spin-container {
  height: 100%;
}
.log-face {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  min-height: 100%;
  overflow: auto;
}
.tool-bar {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  padding: 10px;
  gap: 10px;
  border-bottom: 1px solid var(--tem-border);
}
/*# sourceMappingURL=webhook-debug-log.component.css.map */
